import { useState } from "react";
import { Button, Row, Typography, theme } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
// import { getQueries } from "../../store/action/queries";
import CreateCompany from "../../pages/createCompany";
import CreateClient from "../../pages/createClient";
import CreateQuery from "../../pages/createQuery";
import RequestEntity from "../../pages/requestEntity";
import RequestFy from "../../pages/requestFy";
import { user_role } from "../../consts";
import SendDocumentsModal from "../files/SendDocumentsModal"
import { useIsPrimaryClientView } from "../../utils/useIsPrimaryClientView";


export default function ToolBar() {
  const [showQuery, setShowQuery] = useState(false);
  const [addCompanyModalVisible, setAddCompanyModalVisible] = useState(false);
  const [addClientModalVisible, setAddClientModalVisible] = useState(false);
  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [openEntityModal, setOpenEntityModal] = useState(false);
  const [openFyModal, setOpenFyModal] = useState(false);
  const { isReadOnly } = useIsPrimaryClientView();
  const {
    token: { colorPrimary },
  } = theme.useToken();

  let { role, primary_client_first_logged_in } = useSelector((st) => st.user);
  // const { selected: selectedCompany } = useSelector((st) => st.company || {});
  // const { selected } = useSelector((st) => st.fy || {});
  // const [, setSeed] = useState(1);
  // const reset = () => {
  //   setSeed(Math.random());
  // };

  // const refresh = () => {
  //   // dispatch(getQueries(selectedCompany._id, selected._id));
  //   reset();
  // };

  const Buttons = () => {
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "210px",
          gridTemplateRows: "auto auto auto",
          gap: "10px",
          width: "100%",
        }}
      >
        {role === user_role.ADMIN && (
          <Button type="primary" style={{ width: "100%" }} onClick={() => {
            if ((primary_client_first_logged_in && role === user_role.PRIMARY_CLIENT) || isReadOnly) return;
            setAddCompanyModalVisible(true);
          }}>
            Australian Firm
          </Button>
        )}
        <div style={{ display: "grid", gridTemplateColumns: "100px 100px", gap: "10px" }}>
          <Button type="primary" style={{ width: "100%" }} onClick={() => {
            if ((primary_client_first_logged_in && role === user_role.PRIMARY_CLIENT) || isReadOnly) return;
            setShowQuery(true);
          }}>
            {role === user_role.ADMIN ? "Query" : "Review Points"}
          </Button>
          <Button type="primary" style={{ width: "100%" }} onClick={() => {
            if ((primary_client_first_logged_in && role === user_role.PRIMARY_CLIENT) || isReadOnly) return;
            setAddClientModalVisible(true);
          }}>
            Entity
          </Button>
        </div>
        {role !== user_role.ADMIN && role !== user_role.ACCOUNTANT && (
          <Button type="primary" style={{ width: "100%" }} onClick={() => {
            if ((primary_client_first_logged_in && role === user_role.PRIMARY_CLIENT) || isReadOnly) return;
            setOpenFyModal(true);
          }}>
            Financial Year
          </Button>
        )}

        <Button type="primary" style={{ width: "100%" }} onClick={() => {
          if ((primary_client_first_logged_in && role === user_role.PRIMARY_CLIENT) || isReadOnly) return;
          setOpenDocumentModal(true);
        }}>
          Upload Documents
        </Button>
      </div>
    );
  };


  return (
    <div style={{ minWidth: '10vw' }} className="aside-footer">
      <div
        className="footer-box"
        style={{
          background: colorPrimary,
        }}
      >
        <Typography.Title level={4} style={{ color: "white", marginTop: "4px" }}>
          Create <PlusOutlined size={15} />
        </Typography.Title>

        {user_role.ADMIN !== role ? <div className="btn-div" gutter={[8, 8]}>
          <Buttons />
        </div> : <Row gutter={[8, 8]} >
          <Buttons />
        </Row>}

      </div>
      <CreateQuery show={showQuery} setShow={setShowQuery} />
      <CreateCompany
        visible={addCompanyModalVisible}
        setVisible={setAddCompanyModalVisible}
      />
      <CreateClient
        visible={addClientModalVisible}
        setVisible={setAddClientModalVisible}
      />
      <SendDocumentsModal
        open={openDocumentModal}
        setOpen={setOpenDocumentModal}
      />
      <RequestEntity
        visible={openEntityModal}
        setVisible={setOpenEntityModal}
      />
      <RequestFy
        visible={openFyModal}
        setVisible={setOpenFyModal}
      />
    </div>
  );
}
